export default __webpack_public_path__ + "static/media/image.flameback-technologies-private-limited.c01cd5c5.png";